import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import classnames from 'classnames';
import './Header.css';
import LoginHeader from 'components/LoginHeader';
import NavigationBar from './NavigationBar';
import {Route,Routes,BrowserRouter  } from 'react-router-dom';
import { connect } from 'react-redux';
import { isValidToken } from '../shared/utils/HelperFunctions';
import ARIUserNavigationBar from './ARIUserNavigationBar';

class Header extends React.Component {
    onViewAllOpenPOsHandler(event) {
        event.preventDefault();
        this.props.onNavItemClick("/");
    }
    onSignOutClickHandler(event) {
        event.preventDefault();
        this.props.onSignOutClick();
    }

    render() {
        const messages = defineMessages({
            your_account_link: {
                id: 'your_account',
                description: 'Text for Your Account Link in header',
                defaultMessage: 'Your Account'
            },
            sign_out_link: {
                id: 'sign_out',
                description: 'Text for Sign Out Link in header',
                defaultMessage: 'Sign Out'
            },
            help_link_2: {
                id: 'help_link_2',
                description: 'Text for Help Link in header',
                defaultMessage: 'Help'
            },
            contact_link_2: {
                id: 'contact_link_2',
                description: 'Text for Contact Link in header',
                defaultMessage: 'Contact'
            },            
        });
        const hasValidToken = isValidToken(this.props.token);
        const hasValidPersonaToken = isValidToken(this.props.personaToken);
        const hasAuthenticatedSession = hasValidToken || hasValidPersonaToken;
        const navigationBar = hasAuthenticatedSession ? <NavigationBar /> : null;
        const ariUserNavigationBar = hasValidToken ? <ARIUserNavigationBar /> : null;

        return <div>
            <div className="row site-header">
                <div className="offset-xl-3 col-xl-7 offset-lg-2 col-lg-8 offset-md-1">
                    <Routes>
                        <Route path="/login" element={<LoginHeader />} />
                        <Route path="/" element={navigationBar} />
                        <Route path="/reviewAccountInformation" element={navigationBar} />
                        <Route path="/carWash" element={navigationBar} />
                        <Route path="/carWash/vehicle/:vehicleId" element={navigationBar} />
                        <Route path="/contact/HelpFAQ" element={navigationBar} />
                        <Route path="/contact/FeedbackForm" element={navigationBar} />
                        <Route path="/yourAccount" element={navigationBar} />
                        <Route path="/ariuser" element={ariUserNavigationBar} />
                        <Route path="/dealerDrafts" element={navigationBar} />
                        <Route path="/dealerDrafts/:actionType/:requestNo" element={navigationBar} />
                        <Route path="/linkedVendorAccount" element={null} />
                        <Route path="/recoverPassword" element={null} />
                        <Route path="/resetPassword" element={null} />                   
                        <Route path="/terms" element={null} />
                        <Route path="/exceptions" element={null} />
                        <Route path="/attentionNeeded" element={navigationBar} />
                        <Route path="/AccidentManagement/*" element={navigationBar} />
                        <Route path="/learnMore" element={navigationBar} />

                        <Route path="/vehicle/:vehicleId/documents" element={navigationBar} />

                        <Route path="/po/search" element={navigationBar} />
                        <Route path="/vehicles/vin8/:vin8/:actionType" element={navigationBar} />
                        <Route path="/vehicles/plate/:plate/state/:state/:actionType" element={navigationBar} />
                        <Route path="/vehicles/clientId/:clientId/unitNo/:unitNo/:actionType" element={navigationBar} />
                        <Route path="/vehicles/serviceNo/:serviceNo/:actionType" element={navigationBar} />

                        <Route path="/po/odometer/:vehicleId" element={navigationBar} />
                        <Route path="/po/repairHistory/:vehicleID" element={navigationBar} />
                        <Route path="/po/driverValidationComplaints/:vehicleId" element={navigationBar} />
                        <Route path="/po/complaint/:vehicleId" element={navigationBar} />
                        <Route path="/po/clientParameters/:vehicleID" element={navigationBar} />
                        <Route path="/po/actionRequired/:trackNumber" element={navigationBar} />
                        <Route path="/po/adjustment/:poNumber" element={navigationBar} />
                        <Route path="/po/:actionType/:trackNumber" element={navigationBar} />
                        <Route path="/persona/resetPassword" element={null} />  
                        <Route path="/persona/setupPassword" element={null} />  
                        <Route path="/Persona/*" element={navigationBar} />
                    </Routes>
                </div>
            </div>
        </div>;
    }
}



function mapStateToProps(state, props) {
    return {
        token: state.appState.getIn(['serverData', 'shared', 'token']),
        personaToken:state.appState.getIn(['serverData','shared','personaToken']),
    };
}

export default connect(mapStateToProps)(Header);
